import { ErrorState } from '@tiendanube/components';
import useTranslationCatalog from 'domains/Catalog/useTranslationCatalog';

interface TaxRulesErrorProps {
  readonly onRetryError: () => void;
}

function TaxRulesError({ onRetryError }: TaxRulesErrorProps): JSX.Element {
  const t = useTranslationCatalog('products.detail.invoiceSettings');
  return (
    <ErrorState
      title={t('errorTaxRules.title')}
      action={{
        children: t('errorTaxRules.action'),
        onClick: onRetryError,
      }}
    />
  );
}

export default TaxRulesError;
